import { render } from "./theAdminHome.vue?vue&type=template&id=7ec1a25b&scoped=true"
import script from "./theAdminHome.vue?vue&type=script&langt=ts&lang=js"
export * from "./theAdminHome.vue?vue&type=script&langt=ts&lang=js"

import "./theAdminHome.vue?vue&type=style&index=0&id=7ec1a25b&lang=sass&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec1a25b"]])

export default __exports__